module.exports = __webpack_public_path__ + "static/houses-6281c0c919de3d5d712083fb91db149e.jpg";